import React from "react";
import ValueStatement from "./ValueStatement/valueStatement";
import PropTypes from 'prop-types';

const Banner = ({ campaignData }) => (
  <section className="banner">
    <ValueStatement campaignData={campaignData} />
  </section>
);

Banner.propTypes = {
  campaignData: PropTypes.shape({
    maxLoanAmount: PropTypes.string.isRequired,
    minApr: PropTypes.string.isRequired
  }).isRequired
};

export default Banner;
